import * as Sentry from '@sentry/react';

import { config } from '@/config/config.ts';

export const initSentry = (): void => {
  if (!config.sentryDsn) {
    throw new Error('Sentry dsn env var not available');
  }

  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.appEnv,
    release: config.appRelease,
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
  });

  Sentry.setTag('platform', 'web');
};
